function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import { Button, message, Skeleton, Descriptions, Collapse, Space, Tabs, Divider, Carousel, Tank, Table } from 'antd';
import Common from './includes/Common';
import AddTank from './forms/AddTank';
import { PencilFill, TrashFill, Box, Truck, PCircleFill } from 'react-bootstrap-icons';
import TanksView from './TanksView';
import ProvidersView from './ProvidersView';
import AddProvider from './forms/AddProvider';
import AddProduct from './forms/AddProduct';
import ProductsListView from './ProductsListView';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StationView = function StationView(_ref) {
  var station = _ref.station;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDataChanged = _useState4[0],
    setIsDataChanged = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    tankList = _useState6[0],
    setTankList = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    providersList = _useState8[0],
    setProvidersList = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    productsList = _useState10[0],
    setProductsList = _useState10[1];
  useEffect(function () {
    setIsDataChanged(false);
    axios.all([axios.get(Common.baseApiUrl + 'gettanks/' + station.id.toString() + '/' + Common.currentUser.id.toString()), axios.get(Common.baseApiUrl + 'getproviders/' + station.id.toString() + '/' + Common.currentUser.id.toString()), axios.get(Common.baseApiUrl + 'getproducts/' + station.id.toString() + '/' + Common.currentUser.id.toString())]).then(function (response) {
      setIsDataLoading(true);
      if (response[0].data.status == 200) {
        setTankList([]);
        setTankList(response[0].data.tanks);
      } else {
        message.error({
          content: response[0].data.message,
          delay: 4
        });
      }
      if (response[1].data.status == 200) {
        setProvidersList([]);
        setProvidersList(response[1].data.providers);
      } else {
        message.error({
          content: response[1].data.message,
          delay: 4
        });
      }
      if (response[2].data.status == 200) {
        setProductsList([]);
        setProductsList(response[2].data.products);
      } else {
        message.error({
          content: response[2].data.message,
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [isDataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsx(Col, {
        lg: 12,
        md: 12,
        children: /*#__PURE__*/_jsx("div", {
          style: {
            borderLeft: '1px solid #EEE'
          },
          children: /*#__PURE__*/_jsx(Collapse, {
            ghost: true,
            items: [{
              key: '1',
              label: /*#__PURE__*/_jsx("b", {
                children: " AJOUTER"
              }),
              children: /*#__PURE__*/_jsx(_Fragment, {
                children: /*#__PURE__*/_jsxs(Tabs, {
                  destroyOnHidden: true,
                  animated: true,
                  children: [/*#__PURE__*/_jsx(Tabs.TabPane, {
                    tab: /*#__PURE__*/_jsxs("b", {
                      children: [/*#__PURE__*/_jsx(Box, {
                        size: 22
                      }), " CUVE"]
                    }),
                    children: /*#__PURE__*/_jsx(AddTank, {
                      handler: function handler() {
                        setIsDataChanged(true);
                      },
                      station: station
                    })
                  }, 1), /*#__PURE__*/_jsx(Tabs.TabPane, {
                    tab: /*#__PURE__*/_jsxs("b", {
                      children: [/*#__PURE__*/_jsx(Truck, {
                        size: 22
                      }), " FOURNISSEUR"]
                    }),
                    children: /*#__PURE__*/_jsx(AddProvider, {
                      handler: function handler() {
                        setIsDataChanged(true);
                      },
                      station: station
                    })
                  }, 2), /*#__PURE__*/_jsx(Tabs.TabPane, {
                    tab: /*#__PURE__*/_jsxs("b", {
                      children: [/*#__PURE__*/_jsx(PCircleFill, {
                        size: 22
                      }), " PRODUIT"]
                    }),
                    children: /*#__PURE__*/_jsx(AddProduct, {
                      station: station,
                      handler: function handler() {
                        setIsDataChanged(true);
                      }
                    })
                  }, 3)]
                })
              })
            }]
          })
        })
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsxs(Col, {
        lg: 12,
        md: 12,
        children: [/*#__PURE__*/_jsxs(Carousel, {
          autoplay: true,
          dotsClass: {
            borderColor: '#3A4243'
          },
          style: {
            paddingBottom: '50px'
          },
          children: [/*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(TanksView, {
              tankList: tankList
            })
          }), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(ProvidersView, {
              providersList: providersList
            })
          })]
        }), /*#__PURE__*/_jsx(ProductsListView, {
          productsList: productsList
        })]
      })
    })]
  });
};
export default StationView;